import React, { useState } from 'react'
import styled from 'styled-components'
import DropdownItem from './DropdownItem'
import SearchInput from 'components/SearchInput'

export const Container = styled.div`
width: 100%;
display: ${props => props.visible ? 'block' : 'none'};
margin-top: 10px;
border-radius: 5px;
box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.15);
border: 1px solid #CDCDCD;
background-color: ${props => props.backgroundColor || '#ffffff'};
position: absolute;
left: 0;
top: 100%;
z-index: 4;


// search line
&>div>input[type="text"]{
	height: 40px;
	padding-left: 20px;
	color: #434343;
	font-size: 14px;
	font-weight: 400;
	font-family: Montserrat;
	background-color: #FAFAFA;
	border-radius: 5px 5px 0px 0px;
	&::placeholder {
		color: #CDCDCD;
	}
}
&>div>svg{
	margin-right: 5px;
}
& .inner {
	max-height: 310px;
	overflow-y: auto;
	&>div {
		color: #8DDBCD;;
		font-size: 18px;
		font-weight: 600;
		min-height: 40px;
		padding-left: 20px;
		display: flex;
    	align-items: center;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		max-width: 100%;
		
		&:hover{
			background-color: #f3f2f2;
		}
	}
	&>div:nth-child(2n+1) {
		border-top: 1px solid #CDCDCD;
    	border-bottom: 1px solid #CDCDCD;
	}
}

`

const StyledSearchInput = styled(SearchInput)`
& > input {
	border: none;
	box-shadow: none;
	padding: 0 10px;
}
`

const commonLabels = ['All Branches']

const Dropdown = (props) => {
	const { items = [], customStyles, canSearch = false } = props
	const [filteredItems, setItems] = useState(items)
	const onSearch = value => {
		setItems(() => (!value ? items : items.filter(({ label }) => label.includes(value) || commonLabels.includes(label))))
	}
	return (
		<Container
			style={customStyles}
			{...props}
		>
			{canSearch && <StyledSearchInput onSearch={onSearch} />}
			<div className='inner'>
				{filteredItems.map((item, index) => <DropdownItem key={`${item.label}${index}`} {...item} />)}
			</div>
		</Container>
	)
}

export default Dropdown
